<template>
    <div class="notece_wrap">
        <div class="notice">
            <div class="top flex-between">
                <div class="left_bar">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item><i class="iconfont icon-tongzhi">&nbsp;通知列表</i></el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
            <div>
                <div class="flex-between edite_bar">
                    <div><el-checkbox v-show="!noticeIsEdite" :indeterminate="noticeInfo.isIndeterminate" v-model="noticeInfo.checkAll" @change="allChange">全选</el-checkbox></div>
                    <div v-if="noticeIsEdite" class="dot" @click="noticeIsEdite = !noticeIsEdite">...</div>
                    <div v-else class="flex-between edite_wrap ">
                        <div><i class="iconfont icon-read">&nbsp;已读</i></div>
                        <div><i class="iconfont icon-shanchu" @click="deleteNoticeVisible = true">&nbsp;删除</i></div>
                        <div><i class="iconfont icon-youjiantou-copy" @click="noticeIsEdite = !noticeIsEdite"></i></div>
                    </div>
                </div>
                <div class="notice_content">
                    <div class="notice_item" v-for="notice in noticeData"  :key="notice.noticeId" @click="toSubNotice(notice)">
                        <div :is-dot='notice.isRead == 0' class="item">
                                <div class="flex-between item_content">
                                    <div class="slect_wrap" v-show="!noticeIsEdite">
                                        <el-checkbox-group v-model="selectList" @change="selectChange">
                                            <el-checkbox :label="notice.noticeId" @click.native="stopDefault($event)" :key="notice.noticeId">
                                                &nbsp;
                                            </el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="notice_left"><el-avatar :size="80" :src="notice.senderIcon"></el-avatar></div>
                                    <div class="notice_mid">
                                        <div class="name">{{notice.noticeTitle}}</div>
                                        <div class="notice_brief">本条信息于{{notice.sendTime}}由{{notice.senderName}}发布，单击可查看详情。</div>
                                    </div>
                                    <div class="notice_right flex-column-content">
                                        <div>{{notice.sendTime}}</div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="empty-wrap" v-if="noticeData.length == 0">
            <img src="../../assets/img/offshelf.png" alt="">
        </div>
        <div class="paging_wrap" v-if="pages.totals > 4">
            <el-pagination  background :page-size="4"  layout="prev, pager, next"  @current-change="getNoticeList" :current-page.sync="pages.currentPage" :total="pages.totals"></el-pagination>
        </div>
         <!-- 删除通知 -->
        <el-dialog title='注意' :visible.sync='deleteNoticeVisible' width='30%' center>
            <span>确认删除该通知？</span>
            <span slot='footer' class='dialog-footer'>
              <el-button type='primary' @click='deleteMessage()'>确 定</el-button>
              <el-button @click='deleteNoticeVisible = false;'>取 消</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { deleteNotice, queryNotice } from '../../utils/api';

export default {
    data() {
        return {
            pages: {
                currentPage: 1,
                totals: 1
            },
            noticeData: [],
            selectList: [],//删除时选中数据集合
            noticeInfo: {
                isIndeterminate: false,//设置 indeterminate 状态，只负责样式控制
                    checkAll:false,
                },
                noticeIsEdite:true,
                deleteNoticeVisible:false,
            }
        },
        created(){
            // let url = document.location.href;
        },
        mounted(){

        },
        methods: {
            //查看通知详情
            toSubNotice(content){
                this.$store.commit('setNoticeContent',{content})
                this.$router.push({path:`noticeInfo`})
            },

            //阻止多选框冒泡事件
            stopDefault(e) {
              e.stopPropagation();
            },

            //获取通知列表
            getNoticeList(){
                let params = {
                    keyword:'',
                    page:this.pages.currentPage,
                    size:4
                }
                queryNotice(params).then(res => {
                    this.pages.totals = res.data.totalCount;
                    this.noticeData = res.data.list;
                }).catch(err=>{})
            },

            //全选消息
            allChange(val) {
                // let arrlist = []
                // this.noticeData.forEach(item =>{
                //     arrlist.push(item.id)
                // })
                this.selectList = val ? this.noticeData.map(item => item.noticeId) : [];
                this.noticeInfo.isIndeterminate = false;
            },


            //选择改变
            selectChange(value){
                let checkedCount = value.length;
                this.noticeInfo.checkAll = checkedCount === this.noticeData.length;
                this.noticeInfo.isIndeterminate = checkedCount > 0 && checkedCount < this.noticeData.length;
            },


            //删除消息
            //val为0时为单个删除，为1时为批量删除
            deleteMessage(){
                let params = {
                    noticeIds:this.selectList
                }
                deleteNotice(params).then(res => {
                    this.$message.success('删除成功');
                    this.deleteNoticeVisible = false;
                    this.getNoticeList();
                }).catch(err=>{})

            },
        }
    }
</script>

<style lang="scss" scoped>
.empty-wrap{
    background: white;
}
.notice_content{
    width: 100%;
    box-sizing: border-box;
    .notice_item:hover{
        background: #FAFAFF;
        cursor: pointer;
    }
    .notice_item{
        background: white;
        margin-top: 10px;
        padding: 30px 50px 30px 20px;
        color: #848484;
        .item{
            width: 100%;
            .item_content{
                .slect_wrap{
                    width: 5%;
                    text-align: center;
                }
                .notice_left{
                    width: 8%;
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    // height: 80px;
                }
                .notice_mid{
                    width: 75%;
                    box-sizing: border-box;
                    padding-left: 10px;
                    .notice_brief{
                        overflow:hidden;
                        text-overflow:ellipsis;
                        white-space:nowrap;
                        font-size: 17px;
                    }
                    .name{
                        color: #3C3C3C;
                        font-size: 26px;
                        font-weight: 600;
                        line-height: 2;
                    }

                }
                .notice_right{
                    align-items: center;
                    width: 18%;
                }
            }
        }
    }
}

.edite_bar{
    // width: 100%;
    height: 50px;
    padding: 0px 0px 0px 40px;
    box-sizing: border-box;
    .dot{
        color: #5279F6;
        font-weight: 900;
        font-size: 29px;
    }
    .edite_wrap{
        width: 200px;
        .icon-read:hover{
            color: #5279F6;
        }
        .icon-shanchu:hover{
            color: #F56C6C;
        }
    }
    .dot:hover{
        opacity: 0.7;
        cursor: pointer;
    }
}
.paging_wrap{
    margin-top: 20px;
    height: 60px;
    text-align: center;
}
.notice{
    max-height: 800px;
}
/deep/.el-tabs__nav-scroll{
    background: white;
    padding: 10px 0px 5px 10px;
    margin-top: 15px;
}
.top{
    height: 55px;
    box-sizing: border-box;
    background: white;
    box-sizing: border-box;
    margin-top: 15px;
    padding: 0px 50px 0px 0px;
    color: #848484;
    .icon-shoucangjia,.icon-xianxingwenjianjia{
        margin-right: 5px;
        font-size: 18px;
    }
    .icon-arrowLeft:hover{
            color: #5277F7;
        }
    .icon-xianxingwenjianjia:hover{
        color: #FEA757;
    }
    .left_bar{
        min-width: 100px;
        // max-width: 250px;
        /deep/.el-breadcrumb__inner{
            line-height: 55px;
            font-size: 17px;
            color: white;
        }
        .icon-shoucangjia{
            color: white;
        }
        height: 55px;
        padding: 0px 50px;
        background: url(../../assets/img/collectBar.png) 0 0/100% 100% no-repeat;
    }
}
.notece_wrap{
    padding-bottom: 100px;
}
</style>

